/**
 * Serviço client-side para regeneração do cache SEO (sitemap, robots, etc.).
 */

const REGENERATE_URL = '/api/regenerate-seo';

/**
 * Dispara regeneração do cache SEO após salvar/remover imóvel.
 * Firestore trigger também regenera automaticamente; isto é fallback imediato.
 */
export async function triggerSeoRegeneration() {
  try {
    const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
    const region = process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';

    if (projectId) {
      const url = `https://${region}-${projectId}.cloudfunctions.net/regenerateSeoCacheHttp`;
      await fetch(url, { method: 'POST', mode: 'cors' });
      return { ok: true };
    }

    await fetch(REGENERATE_URL, { method: 'POST' });
    return { ok: true };
  } catch (error) {
    console.warn('[SEO] Regeneração assíncrona — trigger Firestore ativo:', error.message);
    return { ok: false, error: error.message };
  }
}

export async function fetchSeoCacheStats() {
  try {
    const { getFirestore, doc, getDoc } = await import('firebase/firestore');
    const db = getFirestore();
    const snap = await getDoc(doc(db, 'seoCache', 'main'));
    if (!snap.exists()) return null;
    const data = snap.data();
    return {
      stats: data.stats || {},
      updatedAt: data.updatedAt,
      baseUrl: data.baseUrl,
    };
  } catch {
    return null;
  }
}
